import { render, staticRenderFns } from "./SearchFatura.vue?vue&type=template&id=ad24f1c4"
import script from "./SearchFatura.vue?vue&type=script&lang=js"
export * from "./SearchFatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports